import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { featured_products } from "../../data";

export default function FeaturedProducts() {
  return (
    <section className="section-padding py-24 lg:py-32" data-testid="featured-products">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
        <div>
          <p className="overline mb-3">// Bench picks</p>
          <h2 className="h-display text-4xl md:text-5xl">
            Frequently requested instruments.
          </h2>
        </div>
        <Link to="/products" className="btn-ghost self-start md:self-end" data-testid="featured-cta">
          See all products <ArrowUpRight size={14} />
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 grid-cells">
        {featured_products.map((p) => (
          <div key={p.code} className="group hover-lift" data-testid={`product-${p.code.toLowerCase()}`}>
            <div className="aspect-[4/3] overflow-hidden border-b border-ink-700 bg-ink-900">
              <img
                src={p.image}
                alt={p.name}
                className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-300"
              />
            </div>
            <div className="p-6">
              <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-signal-amber mb-2">
                {p.code} · {p.category}
              </p>
              <p className="font-display font-bold text-base leading-tight">{p.name}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
